import { useEffect,useRef } from 'react'

// Review shortcuts: Space flips, 1/2/3 rate Again/Hard/Good, ←/→ move, S suspends.
// Keys typed into fields are ignored, and Space on a focused button keeps its native click.
export type ReviewKeyHandlers={flip?:()=>void;again?:()=>void;hard?:()=>void;good?:()=>void;next?:()=>void;previous?:()=>void;suspend?:()=>void}
export function useReviewKeys(handlers:ReviewKeyHandlers,enabled=true){
 const ref=useRef(handlers);ref.current=handlers
 useEffect(()=>{
  if(!enabled)return
  const onKey=(e:KeyboardEvent)=>{
   if(e.defaultPrevented||e.ctrlKey||e.metaKey||e.altKey||e.repeat)return
   const t=e.target as HTMLElement|null
   if(t&&(t.isContentEditable||/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)))return
   if(e.key===' '&&t?.tagName==='BUTTON')return
   const h=ref.current
   const fn=({' ':h.flip,'1':h.again,'2':h.hard,'3':h.good,ArrowRight:h.next,ArrowLeft:h.previous,s:h.suspend,S:h.suspend} as Record<string,(()=>void)|undefined>)[e.key]
   if(!fn)return
   e.preventDefault();fn()
  }
  window.addEventListener('keydown',onKey)
  return()=>window.removeEventListener('keydown',onKey)
 },[enabled])
}
